<div class="address-selector">
    <ng-template #addressDetailsTooltip>
        @if (hasSelectedAddressDetails()) {
        @let details = selectedAddressDetails();
        <div>
            <div><strong>Direccion:</strong> {{ details?.direccion || '-' }}</div>
            <div><strong>CP:</strong> {{ details?.codigoPostal || '-' }}</div>
            <!-- <div><strong>Place ID:</strong> {{ details?.placeId || '-' }}</div> -->
            <div><strong>Lat:</strong> {{ details?.latitude || '-' }}</div>
            <div><strong>Lng:</strong> {{ details?.longitude || '-' }}</div>
            <!-- <div><strong>Localidad:</strong> {{ details?.localidad || '-' }}</div>
            <div><strong>Provincia:</strong> {{ details?.provincia || '-' }}</div> -->
            <!-- <div><strong>Pais:</strong> {{ details?.pais || '-' }}</div> -->
        </div>
        }
        @else {
        <div>{{ tooltip() }}</div>
        }
    </ng-template>

    <div class="address-input-row">
        <div #autocompleteHost class="autocomplete-host"></div>
        @if (hasSelectedAddressDetails()) {
        <app-tooltip class="address-tooltip" [tooltip]="addressDetailsTooltip"></app-tooltip>
        }
    </div>
    @if (googleApiError()) {
    <p class="text-danger small mt-1" role="alert" aria-live="polite">{{ googleApiError() }}</p>
    }
</div>